// Google Analytics helper functions
// GA Measurement ID: G-0BWCEKNE8S
// GTM Container ID: GTM-NJ4KKS5H

declare global {
  interface Window {
    gtag: (
      command: 'config' | 'event' | 'js' | 'set',
      targetId: string | Date,
      config?: Record<string, unknown>
    ) => void;
    dataLayer: unknown[];
  }
}

// Track page views - call this on route changes
export const trackPageView = (path: string, title?: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('config', 'G-0BWCEKNE8S', {
      page_path: path,
      page_title: title,
    });
  }
};

// Track custom events
export const trackEvent = (
  eventName: string,
  eventParams?: Record<string, string | number | boolean>
) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', eventName, eventParams);
  }
};

// Pre-defined events for SyncroX
export const Analytics = {
  // Form submissions
  formSubmit: (formName: string, formData?: Record<string, string>) => {
    trackEvent('form_submit', {
      form_name: formName,
      ...formData,
    });
  },

  // Integration interactions
  integrationView: (integrationId: string, integrationName: string) => {
    trackEvent('integration_view', {
      integration_id: integrationId,
      integration_name: integrationName,
    });
  },

  integrationSearch: (searchQuery: string, resultsCount: number) => {
    trackEvent('integration_search', {
      search_query: searchQuery,
      results_count: resultsCount,
    });
  },

  // CTA clicks
  ctaClick: (ctaName: string, ctaLocation: string) => {
    trackEvent('cta_click', {
      cta_name: ctaName,
      cta_location: ctaLocation,
    });
  },

  // Webinar interactions
  webinarSignup: (accountingSystem: string, isWaitlist: boolean) => {
    trackEvent('webinar_signup', {
      accounting_system: accountingSystem,
      is_waitlist: isWaitlist,
    });
  },

  // Contact form
  contactFormSubmit: (source: string) => {
    trackEvent('contact_form_submit', {
      source: source,
    });
  },

  // Pricing interactions
  pricingView: () => {
    trackEvent('pricing_view');
  },

  // Solution page views
  solutionView: (solutionType: string) => {
    trackEvent('solution_view', {
      solution_type: solutionType,
    });
  },
};
